module.exports = __webpack_public_path__ + "static/media/video.fc28e321.jpg";